import {
    Dialog,
    DialogContent,
    Box,
    Typography,
    IconButton,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation, Trans } from "react-i18next";

export default function PrivacyPolicyModal({ open, onClose, logoSrc }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const collectList = t("policy.collectList", { returnObjects: true }) || [];
    const purposesList = t("policy.purposesList", { returnObjects: true }) || [];
    const storageList = t("policy.storageList", { returnObjects: true }) || [];
    const sharingList = t("policy.sharingList", { returnObjects: true }) || [];
    const rightsList = t("policy.rightsList", { returnObjects: true }) || [];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullScreen={fullScreen}
            fullWidth
            maxWidth="md"
            aria-labelledby="privacy-title"
            PaperProps={{
                sx: {
                    borderRadius: { xs: 0, sm: 2 },
                    overflow: "hidden",
                    maxHeight: "92vh",
                },
            }}
        >
            {/* Cabeçalho */}
            <Box
                sx={{
                    position: "relative",
                    bgcolor: "#2D2E2F",
                    color: "#ECEDF8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 2,
                    pl: { xs: 2, md: 3 },
                    pr: { xs: 4, md: 6 },
                    py: { xs: 1.5, md: 2 },
                }}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    {logoSrc && (
                        <Box
                            component="img"
                            src={logoSrc}
                            alt="Benext"
                            sx={{ width: { xs: 120, md: 160 }, height: "auto", objectFit: "contain" }}
                        />
                    )}
                </Box>

                <Typography
                    id="privacy-title"
                    sx={{
                        ml: "auto",
                        color: "#00FF4F",
                        fontWeight: 800,
                        textAlign: "right",
                        fontSize: { xs: 18, md: 28 },
                        lineHeight: 1.1,
                    }}
                >
                    <Trans i18nKey="policy.headerTitle" />
                </Typography>

                <IconButton
                    aria-label={t("policy.close", "Fechar")}
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: "#ECEDF8",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.08)" },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </Box>

            {/* Conteúdo */}
            <DialogContent
                sx={{
                    bgcolor: "#FFFFFF",
                    p: { xs: 2.5, md: 3 },
                    "& p, & li": { color: "#0b0c0b", fontSize: { xs: 14, md: 16 }, lineHeight: 1.6 },
                    "& h3": { fontWeight: 800, mt: 3, mb: 1, color: "#000000" },
                }}
            >
                <Typography paragraph>
                    <Trans
                        i18nKey="policy.intro"
                        components={{ bold: <strong /> }}
                    />
                </Typography>

                <Typography component="h3">{t("policy.controllerTitle")}</Typography>
                <Typography paragraph>
                    <Trans i18nKey="policy.controllerBody" components={{ bold: <strong /> }} />
                </Typography>

                <Typography component="h3">{t("policy.collectTitle")}</Typography>
                <Typography paragraph>{t("policy.collectLead")}</Typography>
                <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                    {collectList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </Box>
                <Typography paragraph>
                    <Trans i18nKey="policy.minimization" components={{ bold: <strong /> }} />
                </Typography>

                <Typography component="h3">{t("policy.purposesTitle")}</Typography>
                <Typography paragraph>{t("policy.purposesLead")}</Typography>
                <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                    {purposesList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </Box>
                <Typography paragraph>
                    <Trans i18nKey="policy.legalBasis" components={{ bold: <strong /> }} />
                </Typography>

                <Typography component="h3">{t("policy.storageTitle")}</Typography>
                <Typography paragraph>{t("policy.storageLead")}</Typography>
                <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                    {storageList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </Box>

                <Typography component="h3">{t("policy.sharingTitle")}</Typography>
                <Typography paragraph><Trans i18nKey="policy.sharingLead" components={{ bold: <strong /> }} /></Typography>
                <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                    {sharingList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </Box>

                <Typography component="h3">{t("policy.securityTitle")}</Typography>
                <Typography paragraph>{t("policy.securityBody")}</Typography>

                <Typography component="h3">{t("policy.rightsTitle")}</Typography>
                <Typography paragraph>{t("policy.rightsLead")}</Typography>
                <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                    {rightsList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                </Box>

                <Typography paragraph>{t("policy.exercise")}</Typography>

                <Typography component="h3">{t("policy.changesTitle")}</Typography>
                <Typography paragraph>{t("policy.changesBody")}</Typography>

                <Typography component="h3">{t("policy.contactTitle")}</Typography>
                <Typography paragraph>
                    <Trans i18nKey="policy.contactBody" components={{ bold: <strong /> }} />
                </Typography>
            </DialogContent>
        </Dialog>
    );
}